import React, { Component, useEffect, useState } from 'react'
import { questionActions } from '../../store/actions'
import { connect } from 'react-redux'
import Input from '../../module/input'
import history from '../../route/history'

const QuestionPwdPopup = (props) => {
  const queryString = require('query-string')

  const [passwd, setPasswd] = useState('')

  const [state, setState] = useState({})

  useEffect(() => {
    const obj = queryString.parse(props?.search)
    obj?.schText && !obj?.schCode && (obj.schCode = 'TITLE')
    obj.isConfirm = props.pwdConfirm

    if (props.pwdConfirm === true) {
      obj.token = props.token
      switch (props.pwdType) {
        case 'EDIT':
          history.push({ pathname: '/questionwrite', state: { seq: props.selectSeq } })
          return
        case 'DELETE':
          props.delete({ seq: props.selectSeq, token: props.token })
          alert("삭제되었습니다.")
          return
        case 'DETAIL':
          history.push({ pathname: '/question/' + props.selectSeq, state: obj })
          props.showPwdPopup(false, null)
          return
        default:
          return
      }
    } else if (props.pwdConfirm === false) {
      setState({
        ...state,
        errMessage: '비밀번호가 일치하지 않습니다.',
      })
    }
  }, [props?.pwdConfirm])

  /**
   * 삭제 콜백
   */
  useEffect(() => {
    if (props.pwdType === 'DELETE' && props?.isDelete === true) {
      props.showPwdPopup(false, null)
      history.replace('/question')
    }
  }, [props.isDelete])


  /**
   * 비밀번호 유효성 체크
   */
  const goNext = () => {
    if (passwd?.length <= 0) {
      setState({
        ...state,
        errMessage: '비밀번호를 입력해주세요.',
      })
    } else {
      props.checkPwd(props.selectSeq, { passwd })
    }
  }

  const handleChange = (e) => {
    const { value } = e.target
    setPasswd(value)
  }

  /**
   * 공개 문의글 삭제
   * ISMS 20250311 사용자 계정 ID/PW와 등록한 사람의 계정이 동일해야하는 체크로직 필요
   */
  const pDelete = () => {
    props.delete({ seq: props.selectSeq, token: props.token })
    props.showPwdPopup(false, null)
    alert("삭제되었습니다.")
    history.replace('/question')
  
  }

  return (
    <React.Fragment>
      {
        props.pwdType !== "PDELETE" ?
        <React.Fragment>
          <div className="alert-wrap">
            <div className="alert-box">
              <p>문의글 작성시 등록한 비밀번호를 입력해주세요.</p>    
              <br /> 
                <div className="modal-body">
                  <Input
                    type="password"
                    className="form-control input-text m-b-20"
                    placeholder="비밀번호"
                    id="passwd"
                    name="passwd"
                    onChange={handleChange}
                    value={passwd || ''}
                    errMessage={state?.errMessage}
                  />
                </div>
                <div className="modal-footer alert-btn">
                  <button type="btn" className="alert-clos" onClick={goNext}>
                    확인
                  </button>
                  <button type="btn" className="alert-clos" onClick={() => props.showPwdPopup(false, null)}>
                    취소
                  </button>
                </div>
            </div>
          </div>
        </React.Fragment>
        :
        <React.Fragment>
          <div className="alert-wrap">
            <div className="alert-box">
              <p>삭제하시겠습니까?</p>    
              <br /> 
                <div className="modal-footer alert-btn">
                  <button type="btn" className="alert-clos" onClick={pDelete}>
                    확인
                  </button>
                  <button type="btn" className="alert-clos" onClick={() => props.showPwdPopup(false, null)}>
                    취소
                  </button>
                </div>
            </div>
          </div>
        </React.Fragment>
      }
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    pwdType: state.quest.pwdType,
    selectSeq: state.quest.selectSeq,
    pwdConfirm: state.quest.pwdConfirm,
    token: state.quest.token,
    isDelete: state.quest.isDelete,
  }
}
const actionCreators = {
  showPwdPopup: questionActions.showPwdPopup,
  checkPwd: questionActions.checkPwd,
  delete: questionActions.del,
}

export default connect(mapStateToProps, actionCreators)(QuestionPwdPopup)
